export default [
  {
    path: '/admin/attendance-devices',
    name: 'attendance-device',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/attendance-device')
  }
]
